import React from "react"
import { useTranslation } from "react-i18next"

import { connect } from "scrivito"
import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

import { PortfolioProductSelect } from "widgets/portfolio-product-select/PortfolioProductSelect"
import { ProductConfiguratorResult } from "widgets/product-configurator/model/useProductConfiguratorModel"

import { usePortfolioProductSelectOverlayModel } from "./hooks/usePortfolioProductSelectOverlayModel"
import "./styles/_portfolio-product-select-overlay.scss"

export interface ProductConfigurationModelSelectionOverlayPayload {
  onSubmit: (configuration: ProductConfiguratorResult) => void
}

export interface PortfolioProductSelectOverlayProps {
  payload: ProductConfigurationModelSelectionOverlayPayload
}

function PortfolioProductSelectOverlayComponent(
  props: PortfolioProductSelectOverlayProps
) {
  const { t } = useTranslation()
  const { closeOverlay } = useCurrentOverlay()
  const model = usePortfolioProductSelectOverlayModel(props)

  return (
    <OverlayWrapper
      id="portfolio-product-select-overlay"
      className="portfolio-product-select-overlay"
      classNamePrefix="portfolio-product-select-overlay"
      headline={t("Product.Configuration.ChooseConfigurator")}
      mobileFullscreen
    >
      <OverlayHeader.Container prefix="portfolio-product-select-overlay">
        <OverlayHeader.CloseButton onClick={closeOverlay} className="primary" />
        <OverlayHeader.Title>
          {t("Product.Configuration.ChooseConfigurator")}
        </OverlayHeader.Title>
      </OverlayHeader.Container>
      <div className="overlay-scroll-container">
        <PortfolioProductSelect {...model} />
      </div>
    </OverlayWrapper>
  )
}

export const PortfolioProductSelectOverlay = React.memo(
  connect(PortfolioProductSelectOverlayComponent)
) as typeof PortfolioProductSelectOverlayComponent

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PORTFOLIO_PRODUCT_SELECT_OVERLAY: ProductConfigurationModelSelectionOverlayPayload
  }
}
